import { render, staticRenderFns } from "./ResumenSeminarios.vue?vue&type=template&id=069f2cd0"
import script from "./ResumenSeminarios.vue?vue&type=script&lang=js"
export * from "./ResumenSeminarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports